import { Device as CapacitorDevice } from "@capacitor/device";
import { Capacitor } from "@/lib/capacitor";

export const Device = (function () {
  async function getId() {
    return (await CapacitorDevice.getId()).identifier;
  }

  async function getInfo() {
    return await CapacitorDevice.getInfo();
  }

  async function getBatteryInfo() {
    return await CapacitorDevice.getBatteryInfo();
  }

  async function getLanguageCode() {
    return await CapacitorDevice.getLanguageCode();
  }

  async function getLanguageTag() {
    return await CapacitorDevice.getLanguageTag();
  }

  /**
   * Get unique device identifier for push notification registration Format: {deviceId}-{platform}
   * Example: "ABC123-ios" or "XYZ789-android"
   */
  async function getDeviceIdentifier() {
    const deviceId = await getId();
    const platform = Capacitor.Platform;
    return `${deviceId}-${platform}`;
  }

  /**
   * Get device information for display purposes Returns a user-friendly name like "John's iPhone
   * (iOS)"
   */
  async function getDeviceName() {
    const info = await getInfo();
    const platform = Capacitor.Platform;
    const platformLabel = platform === "ios" ? "iOS" : "Android";

    // Use device name if available, otherwise use model
    const deviceName = info.name || info.model || "Device";

    return `${deviceName} (${platformLabel})`;
  }

  return {
    ...CapacitorDevice,
    getId,
    getInfo,
    getBatteryInfo,
    getLanguageCode,
    getLanguageTag,
    getDeviceIdentifier,
    getDeviceName,
  };
})();

export type * from "@capacitor/device";
